(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ManageInstrumentController', ManageInstrumentController);

    ManageInstrumentController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService','$uibModalInstance','InstrumentView','entity','DateUtils','Workflow','IntradayMarket','MessageBox'];

     function ManageInstrumentController($scope, $state, $rootScope, GlobalValues, workflowSharedService, $uibModalInstance,InstrumentView,entity,DateUtils,Workflow,IntradayMarket,MessageBox) {
        var vm = this;
        vm.manageInstrument=entity;   
        
        vm.clear=clear;
        vm.save=save;
        vm.clicked=false;
        $scope.showButton = false;
        $scope.showApproveRejectButton=false;
        $scope.showDiscardButton = false;
    	$scope.showResubmitButton=false;
        vm.resubmit = resubmit;
        vm.globalValues = GlobalValues;
        vm.discard = discard;
        vm.reject= reject;
        vm.approve= approve;
        vm.viewMode=false;
        vm.showEffectiveFrom=false;
        
        $scope.showButton = false;
        vm.orgId = vm.globalValues.getOrgId();

        IntradayMarket.getIntradayMarketSessionSettingsForInstrument({"instrument":'InterbankSPOT'}, onGetMarketSessionSuccess, onGetMarketSessionFailure);
		
    	function onGetMarketSessionSuccess(result){
        	vm.marketSessionSettings = result;
        }

        function onGetMarketSessionFailure(){
        }
           
        if(workflowSharedService.viewFrom == 'instrumentView'){
        	vm.manageInstrument=entity;
        	$scope.showButton = true;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;
        	vm.viewMode=false;              
        }
        else if(workflowSharedService.viewFrom == 'manage_instrumenttodolist_resubmit') {
        	vm.manageInstrument =  angular.fromJson($rootScope.payload);
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=true;
        	vm.viewMode=false;
        }
        else if(workflowSharedService.viewFrom == 'manage_instrumenttodolist_checker') {
        	vm.manageInstrument =  angular.fromJson($rootScope.payload); 
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = true;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;
        }
        else if(workflowSharedService.viewFrom == 'manage_instrumenttodolist_maker') {
        	vm.manageInstrument =  angular.fromJson($rootScope.payload); 
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = true;
        	$scope.showResubmitButton=false;
        }
        else if(workflowSharedService.viewFrom=='manage_instrument_auditlog'){
        	vm.manageInstrument =  angular.fromJson($rootScope.payload); 
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;

        }
		
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function save () { 
                if (vm.marketSessionSettings && vm.marketSessionSettings.sessionStatus == 'OPEN') {
                MessageBox.openMessageBox("Alert", "Modification is permitted only after the IB.SPOT market hours...!", "Ok", "");
                vm.viewMode=true;
                return;
                 }
            
                if(vm.manageInstrument.currencyPair != null && vm.manageInstrument.currencyPair != undefined){
                vm.manageInstrument.currencyPairId = vm.manageInstrument.currencyPair.id;
                }
				InstrumentView.update({
					"orgId" : GlobalValues.getOrgId()
				}, vm.manageInstrument, onSaveSuccess, onSaveError);	
         }
      
       
        function onSaveSuccess (result) {
        	 $uibModalInstance.close(result);  
        }
        
      
        function onSaveError () {
        	
        	vm.clicked = false;
        }
        function resubmit() {
        	
        	
        	InstrumentView.resubmit({"taskId" : $rootScope.taskID},  vm.manageInstrument, onResubmitSuccess, onResubmitError);
        	
       		
        	$uibModalInstance.dismiss('cancel');
        }
        
        function onResubmitSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);
        }        
        function onResubmitError(error) {
        	vm.clicked = false;
        }
        
        function approve() { 
        	InstrumentView.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
        	$uibModalInstance.dismiss('cancel');     	
        }
        
        function onApproveSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onApproveError(error) {
        	
        }
       
        function reject() { Workflow.rejectTask($rootScope.taskID); }

        function discard() {
        	InstrumentView.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onDiscardError(error) {
        	
        }
        
        

       
     }   
})();
